'use client'

import { type UseMutationOptions, useMutation } from '@tanstack/react-query'

import { getAccountAction } from './account.actions'
import type { AccountConfig } from './account.types'

// Keys (inline, as they are simple and used only here for now)
const accountsKeys = {
  all: ['accounts'] as const,
  bySubdomain: (subdomain: string) =>
    [...accountsKeys.all, 'by-subdomain', subdomain] as const,
}

/**
 * Client hook that looks up account config by subdomain.
 * Uses a Server Action to fetch data (BFF pattern).
 */
export function useGetAccountBySubdomain(
  options?: UseMutationOptions<AccountConfig, Error, string>,
) {
  return useMutation({
    mutationKey: accountsKeys.all,
    mutationFn: (subdomain: string) => getAccountAction(subdomain),
    ...options,
  })
}
